import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { t } from '../i18n.js';

/**
 * De security score als klein rondje rechtsboven, naast de versie en jou (Bernhard, 2026-10-28), met een link naar de
 * beveiligingsstatus. Een medewerker ziet de gekozen klant, of bij Alle klanten het gemiddelde; een klant zijn eigen.
 */
const OORDEEL = { goed: 'Goed', redelijk: 'Redelijk', aandacht: 'Aandacht nodig' };

export default function Scoreknop({ haal, sleutel, naar }) {
  const q = useQuery({ queryKey: [...sleutel, 'score'], queryFn: haal, refetchInterval: 5 * 60_000, retry: false });
  const d = q.data?.data;
  if (!d) return null;
  const o = 2 * Math.PI * 15;
  const titel = d.scope === 'gemiddeld'
    ? t('Gemiddelde security score van {aantal} klanten: {n} ({oordeel})', { aantal: d.tenants, n: d.score, oordeel: t(OORDEEL[d.verdict]) })
    : t('Security score {n} van 100 ({oordeel})', { n: d.score, oordeel: t(OORDEEL[d.verdict]) });
  return (
    <Link to={naar} className={`scoreknop ${d.verdict}`} title={titel} aria-label={titel}>
      <svg viewBox="0 0 38 38" aria-hidden="true">
        <circle cx="19" cy="19" r="15" fill="none" className="spoor" strokeWidth="3.5" />
        <circle cx="19" cy="19" r="15" fill="none" className="boog" strokeWidth="3.5" strokeLinecap="round" strokeDasharray={`${(o * d.score) / 100} ${o}`} />
      </svg>
      <span className="n">{d.score}</span>
    </Link>
  );
}
